import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);
    const menuRef = useRef(null);
    const toggleRef = useRef(null);

    const toggleMobileDropdown = (target) => {
        setOpenDropdown(openDropdown === target ? null : target);
    };

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
        setOpenDropdown(null);
    };

    // Close mobile menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                mobileMenuOpen &&
                menuRef.current &&
                !menuRef.current.contains(e.target) &&
                toggleRef.current &&
                !toggleRef.current.contains(e.target)
            ) {
                closeMobileMenu();
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, [mobileMenuOpen]);

    return (
        <header className="bg-primary shadow-md sticky top-0 z-50">
            <div className="container mx-auto px-4 py-3 flex items-center justify-between">
                {/* LOGO */}
                <Link to="/" className="logo-wrapper">
                    <div className="logo-text">
                        <span className="logo-trust logo-trust-shimmer">
                            <i className="fas fa-place-of-worship text-3xl text-white"></i>{" "}
                            Venkatadri Seva Trust (R)
                        </span>
                    </div>
                </Link>

                {/* DESKTOP NAV */}
                <nav className="hidden md:flex items-center space-x-6 text-white">
                    <Link to="/" className="nav-link font-medium">Home</Link>

                    {/* About Us dropdown */}
                    <div className="nav-dropdown">
                        <span className="nav-link font-medium">
                            About Us
                            <i className="fas fa-chevron-down chevron text-[0.5rem] opacity-70"></i>
                        </span>
                        <div className="dropdown-menu">
                            <Link to="/overview"><i className="fas fa-info-circle"></i> Overview</Link>
                            <Link to="/certificates"><i className="fas fa-certificate"></i> Certificates</Link>
                        </div>
                    </div>

                    {/* What We Do dropdown */}
                    <div className="nav-dropdown">
                        <span className="nav-link font-medium">
                            What We Do
                            <i className="fas fa-chevron-down chevron text-[0.5rem] opacity-70"></i>
                        </span>
                        <div className="dropdown-menu">
                            <Link to="/care-for-senior-citizens"><i className="fas fa-user-friends"></i> Care for Senior Citizens</Link>
                            <Link to="/child-welfare"><i className="fas fa-child"></i> Child Welfare</Link>
                            <Link to="/disability-support"><i className="fas fa-wheelchair"></i> Support for Persons with Disabilities</Link>
                            <Link to="/health-medical"><i className="fas fa-heartbeat"></i> Health & Medical Assistance</Link>
                            <Link to="/education-for-poor"><i className="fas fa-graduation-cap"></i> Education for Poor Students</Link>
                            <Link to="/environment-conservation"><i className="fas fa-leaf"></i> Environment & Nature Conservation</Link>
                            <Link to="/community-service"><i className="fas fa-hands-helping"></i> Community Service</Link>
                        </div>
                    </div>

                    <div className="nav-dropdown">
                        <span className="nav-link font-medium">
                            Become A Donor
                            <i className="fas fa-chevron-down chevron text-[0.5rem] opacity-70"></i>
                        </span>
                        <div className="dropdown-menu">
                            <Link to="/donor-benefits"><i className="fas fa-gift"></i>Benefits</Link>
                            <Link to="/tirupati-darshanam"><i className="fas fa-place-of-worship"></i>Thirupathi Darshanam & Accommodation - Free</Link>

                        </div>
                    </div>


                    <Link to="/contact" className="nav-link">Contact</Link>
                </nav>

                {/* Donate button */}
                <Link
                    to="/donate"
                    className="hidden md:inline-block bg-white text-primary px-6 py-2 rounded-lg hover:bg-gray-100 transition-smooth font-semibold"
                >
                    Donate Now
                </Link>

                {/* Mobile toggle */}
                <button
                    ref={toggleRef}
                    className="md:hidden text-white text-2xl"
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                >
                    <i className="fas fa-bars"></i>
                </button>
            </div>

            {/* MOBILE MENU */}
            <div
                ref={menuRef}
                className={`md:hidden bg-white border-t border-gray-200 ${mobileMenuOpen ? 'block' : 'hidden'}`}
            >
                <div className="flex flex-col p-4 space-y-3">
                    <Link to="/" className="text-primary font-medium hover:text-primary-dark" onClick={closeMobileMenu}>
                        Home
                    </Link>

                    {/* About Us mobile accordion */}
                    <div>
                        <button
                            className={`mobile-dropdown-toggle ${openDropdown === 'mobileAbout' ? 'open' : ''}`}
                            onClick={() => toggleMobileDropdown('mobileAbout')}
                        >
                            About Us
                            <i className="fas fa-chevron-down chevron"></i>
                        </button>
                        <div className={`mobile-sub-menu ${openDropdown === 'mobileAbout' ? 'open' : ''}`}>
                            <Link to="/overview" onClick={closeMobileMenu}><i className="fas fa-info-circle"></i> Overview</Link>
                            <Link to="/certificates" onClick={closeMobileMenu}><i className="fas fa-certificate"></i> Certificates</Link>
                        </div>
                    </div>

                    {/* What We Do mobile accordion */}
                    <div>
                        <button
                            className={`mobile-dropdown-toggle ${openDropdown === 'mobileWhatWeDo' ? 'open' : ''}`}
                            onClick={() => toggleMobileDropdown('mobileWhatWeDo')}
                        >
                            What We Do
                            <i className="fas fa-chevron-down chevron"></i>
                        </button>
                        <div className={`mobile-sub-menu ${openDropdown === 'mobileWhatWeDo' ? 'open' : ''}`}>
                            <Link to="/care-for-senior-citizens" onClick={closeMobileMenu}><i className="fas fa-user-friends"></i> Care for Senior Citizens</Link>
                            <Link to="/child-welfare" onClick={closeMobileMenu}><i className="fas fa-child"></i> Child Welfare</Link>
                            <Link to="/disability-support" onClick={closeMobileMenu}><i className="fas fa-wheelchair"></i> Support for Persons with Disabilities</Link>
                            <Link to="/health-medical" onClick={closeMobileMenu}><i className="fas fa-heartbeat"></i> Health & Medical Assistance</Link>
                            <Link to="/education-for-poor" onClick={closeMobileMenu}><i className="fas fa-graduation-cap"></i> Education for Poor Students</Link>
                            <Link to="/environment-conservation" onClick={closeMobileMenu}><i className="fas fa-leaf"></i> Environment & Nature Conservation</Link>
                            <Link to="/community-service" onClick={closeMobileMenu}><i className="fas fa-hands-helping"></i> Community Service</Link>
                        </div>
                    </div>


                    <div>
                        <button
                            className={`mobile-dropdown-toggle ${openDropdown === 'mobileDonor' ? 'open' : ''}`}
                            onClick={() => toggleMobileDropdown('mobileDonor')}
                        >
                            Become A Donor
                            <i className="fas fa-chevron-down chevron"></i>
                        </button>
                        <div className={`mobile-sub-menu ${openDropdown === 'mobileDonor' ? 'open' : ''}`}>
                            <Link to="/donor-benefits" onClick={closeMobileMenu}><i className="fas fa-gift"></i> Benefits</Link>
                            <Link to="/tirupati-darshanam" onClick={closeMobileMenu}><i className="fas fa-place-of-worship"></i>Thirupathi Darshanam & Accommodation - Free</Link>



                        </div>
                    </div>



                    <Link to="/contact" className="text-primary hover:text-primary-dark" onClick={closeMobileMenu}>
                        Contact
                    </Link>
                    <Link
                        to="/donate"
                        className="bg-primary text-white text-center py-2 rounded-lg hover:bg-primary-dark"
                        onClick={closeMobileMenu}
                    >
                        Donate Now
                    </Link>
                </div>
            </div>
        </header>
    );
};

export default Header;